import { animationTransition } from '@shared/utils/animationTransition';
import { Box, styled } from '@withjoy/joykit';
import { StyleSystemProps } from '@withjoy/joykit/components/Box/Box.types';
import { StyledProductPhoto } from '../ProductPhoto/ProductPhoto.styles';

export const StyledPlusButton = styled(Box)``;
export const ProductShelfContent = styled(Box)``;
export const ShelfCarouselTitle = styled(Box)<{ $isDialog: boolean }>`
  ${({ $isDialog = false }) => {
    if ($isDialog) {
      return {
        width: '64rem',
      };
    }
    return null;
  }}
`;
export const ProductShelfContentOver = styled(Box)`
  @media (hover: hover) {
    ${StyledProductPhoto} {
      transition: ${animationTransition('transform')};
    }
    &:hover {
      ${StyledProductPhoto} {
        transform: scale(1.03);
      }
    }
  }
`;

const shelfCarouselStyles: StyleSystemProps = {
  flexDirection: 'column',
  overflow: 'hidden',
};

const shelfCarouselTitleStyles: StyleSystemProps = {
  fontSize: 24,
  fontWeight: 600,
  paddingBottom: 6,
  maxWidth: '100%',
};

const plusButtonStyled: StyleSystemProps = {
  color: 'mono10',
  position: 'absolute',
  top: 4,
  right: 4,
  transition: 'color 0.2s',
  _hover: {
    color: 'mono14',
  },
  _disabled: {
    cursor: 'default',
  },
};

const productShelfContainerStyles: StyleSystemProps = {
  paddingRight: '24px',
  width: '100%',
  height: '100%',
};

const productShelfContentStyles: StyleSystemProps = {
  width: '100%',
};

const productShelfContentOverStyles: StyleSystemProps = {
  width: '100%',
  cursor: 'pointer',
};

export const styles = {
  shelfCarousel: shelfCarouselStyles,
  shelfCarouselTitle: shelfCarouselTitleStyles,
  plusButton: plusButtonStyled,
  productShelfContainer: productShelfContainerStyles,
  productShelfContent: productShelfContentStyles,
  productShelfContentOver: productShelfContentOverStyles,
};
